import CommonService from '../services/common.service'

const initialState = { countries: [] };

CommonService.getCountries().then( (res) => {
  initialState.countries = res.data;
})

export default {
  namespaced: true,
  state: initialState,
  actions: {
  },
  mutations: {
  }
};